import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { useD3Selection } from 'src/hooks'

function Intervals({ data, scale, yOffset = 0, width = 4 }) {
  return (
    <g>
      {data.map(({ startDate, endDate, color }, index) => (
        <Interval
          key={index}
          startDate={startDate}
          endDate={endDate}
          color={color}
          scale={scale}
          yOffset={yOffset}
          width={width}
        />
      ))}
    </g>
  )
}

Intervals.propTypes = {
  ...Interval.propTypes,
  data: PropTypes.array,
}

function Interval({ startDate, endDate, color = 'primary', yOffset = 0, width = 4, scale }) {
  const [ref, useSelectionEffect] = useD3Selection()

  useSelectionEffect(
    selection => {
      selection.attr('x1', scale(startDate)).attr('x2', isNil(endDate) ? scale.range()[1] : scale(endDate))
    },
    [scale, startDate, endDate]
  )

  return <line y1={yOffset} y2={yOffset} strokeWidth={width} stroke={color} ref={ref} />
}

Interval.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  color: PropTypes.string,
  scale: PropTypes.func,
  yOffset: PropTypes.number,
  width: PropTypes.number,
}

export default React.memo(Intervals)
